import {ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Input, OnDestroy, OnInit} from '@angular/core';
import {filter, map, Observable, of, Subscription, switchMap, tap} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {ContractRoadmapModel} from '../../../../models/contract.model';
import {GraphKnDataService} from '../../../graph-konva/services/graph-kn.data.service';
import {TFormState} from '../../../../models/forms.model';
import {ContractStatusIconMap} from '../../models/contract-styling-consts';
import {Title} from '@angular/platform-browser';
import {MatDialog} from '@angular/material/dialog';
import {CkeditorComponent} from '../../../../components/form/inputs/ckeditor/ckeditor.component';
import {FormControl} from '@angular/forms';
import {ContractIconService} from '../../services/contract-icon.service';
import {ContractTagsService} from '../../services/contract-tags.service';
import {ContractDataService} from '../../services/contract-data.service';
import {
  ContractStatusToAddTragets,
    contractStatusToModifyRM,
    IContractDataModel,
    IRoadMapHistory,
    IStepDataToOpen
} from '../../models/contract-internal-models';
import {TranslateService} from '@ngx-translate/core';
import {ContractFormService} from '../../services/contract-form.service';
import {ContractLoadService} from '../../services/contract-load.service';
import {ContractActionsMainService} from '../../services/contract-actions-main.service';
import {ContractRestrictionService} from '../../services/contract-restrictions.service';
import {ContractAvatarsService} from '../../services/contract-avatar.service';
import {TContractGraphType} from '../../../graph-konva/models/graph-kn.cm-api-models';
import {ContractGraphService} from '../../services/contract-graph.service';
import {ContractGetTargetDataService} from '../../services/contract-get-target-data.service';
import { ContractAutoUpdateService } from '../../services/contract-autoupdate.service';
import { ContractFinanceService } from '../../services/contract-finance.service';

@Component({
    selector: 'app-contract-form',
    templateUrl: './contract-form.component.html',
    styleUrl: './contract-form.component.scss',
    changeDetection:ChangeDetectionStrategy.OnPush
})
export class AppContractFormComponent implements OnInit, OnDestroy {
    @Input() public contractGuid: string = '';
    public contractTableRoute:string[] | undefined = undefined
    public verifyDomainOnLoad:boolean = true // false for opening interdomain subcontracts inside dialogs
    public contractData:IContractDataModel|undefined=undefined;
    public contractRoadmapCurrent:ContractRoadmapModel|null=null;
    private subscriptions = new Subscription
    public formState:TFormState = 'Default'
    public contractNameFC = new FormControl('')
    public titleChanged$!: Observable<boolean>
    public selectedStepData:IStepDataToOpen|null = null
    public showDetailedParties:boolean = false
    public showFullContractDesc:boolean = false
    public openAsDialog:boolean = false
    public contractGraphType = new FormControl<TContractGraphType | ''>('');
    public contractStatusesToShowRMmenu = [...contractStatusToModifyRM,...ContractStatusToAddTragets]
    public contractStatusIconMap = ContractStatusIconMap
    constructor(
      public contractGetTargetDataService: ContractGetTargetDataService,
      public contractDataService: ContractDataService,
      public contractLoadService: ContractLoadService,
      public contractAvatarsService: ContractAvatarsService,
      public contractFormService: ContractFormService,
      public contractActionsMainService: ContractActionsMainService,
      public contractRestrictionService: ContractRestrictionService,
      public contractGraphService: ContractGraphService,
      public contractTagsService: ContractTagsService,
      public contractAutoUpdateService: ContractAutoUpdateService,
      public contractFinanceService: ContractFinanceService,
      private icons:ContractIconService,
      private activatedRoute: ActivatedRoute,
      private graphKnDataService: GraphKnDataService,
      private router:Router,
      private titleServce:Title,
      private dialog: MatDialog,
      private translateService:TranslateService,
      private cds:ChangeDetectorRef,
    ) { }
    @HostListener('window: beforeunload', ['$event'])
    deactivate(): boolean {
      return !this.contractDataService.subContractEdited.value
    }
    canDeactivate(): boolean | Observable<boolean> {
      if (this.contractDataService.subContractEdited.value) {
        return confirm(this.translateService.instant('CONFIRM.TEXT.LEAVE_PAGE'));
      } else {
        return true;
      }
    }
    switchView() {
      this.contractData?.contract?.contract.status
        this.router.navigate(['account', 'contract_old', this.contractGuid])
    }
    ngOnDestroy(): void {
      this.contractDataService.ContractDataCachedByGuid.delete(this.contractGuid)
      this.subscriptions.unsubscribe()
      let title = this.translateService.instant('PAGES_TITLES.DEFALUT')
      setTimeout(() => {
        this.titleServce.setTitle(title)
      }, 100);
      this.contractData? this.contractAutoUpdateService.setAutoReloadInterval(this.contractData,false) : null;
    }
    ngOnInit(): void {
      this.contractAvatarsService.bSubAvatarsReady.next(false)
      this.setSubscriptions()
    }
    setSubscriptions() {
      //avatars ready
      this.subscriptions.add(this.contractAvatarsService.bSubAvatarsReady.asObservable().pipe(filter(data=>data===true)).subscribe(()=> this.cds.detectChanges()))
      //load
      this.subscriptions.add(
        of(this.contractGuid)
          .pipe(
              switchMap(guid => guid ? of({guid: this.contractGuid}) : this.activatedRoute.params),
              tap(params => this.contractGuid = params.guid))
          .subscribe(() => this.contractLoadService.onLoadingContract(this.contractGuid,undefined,this.verifyDomainOnLoad))
      );
      //get loaded contract
      this.subscriptions.add(
        this.contractDataService.bSubContractDataIsCached.asObservable()
        .pipe(filter(data=>data.guid === this.contractGuid))
        .subscribe(()=>{
            this.contractData=this.contractDataService.ContractDataCachedByGuid.get(this.contractGuid)
            this.contractData?.contract?.roadmap_active? 
                this.contractRoadmapCurrent = this.contractData?.contract?.roadmap_active : null;
            this.titleServce.setTitle(this.translateService.instant('PAGES_TITLES.CONTRACT_DETAIL') + ' '+ this.contractData?.contract?.contract?.name) 
            this.contractNameFC.setValue(this.contractData?.contract?.contract?.name||'')
            this.formState = 'Default'
            this.contractDataService.subContractDetectChanges.next(true)
            this.cds.detectChanges();
            }))
      //reload contract
      this.subscriptions.add(
        this.contractDataService.subContractReloadContract.asObservable()
        .subscribe(reload=>reload? this.contractLoadService.onLoadingContract(this.contractGuid,undefined,this.verifyDomainOnLoad) : null))
      //roadMap asks to open step
      this.subscriptions.add(this.contractDataService.subContractStepToOpenOne.asObservable()
      .pipe(filter(data=>data.contractGuid === this.contractGuid))  
      .subscribe(data=>this.selectedStepData = data))
      //title change
      this.titleChanged$ = this.contractNameFC.valueChanges.pipe(map((data)=> data!==this.contractData?.contract?.contract.name))
      //graph type
			this.subscriptions.add(this.contractGraphType.valueChanges.subscribe(type => type ? this.contractDataService.contractGraphTypeSub.next(type) : null))
			this.subscriptions.add(this.graphKnDataService.subSettingsUploaded$.subscribe(type => this.contractGraphType.patchValue(type.contractGraphType, {emitEvent: false})))
      //roadMap version changed
      this.subscriptions.add(
        this.contractDataService.subRoadMapSelected.asObservable()
        .pipe(filter(data=>data && (data as IRoadMapHistory).label>=''))
        .subscribe(data=>this.onRoadMapVersionChanged((data as IRoadMapHistory)))
      )
      //step pointer calculated
      this.subscriptions.add(this.contractDataService.subStepFormCDS.asObservable().subscribe(()=>this.cds.detectChanges()))
    }
    showRoadMapHistoryList(){
      this.contractFormService.checkInterDomainRedirect(this.contractData?.contract?.contract).subscribe(()=>{
        this.contractDataService.subRoadMapHistoryListOpened.next(true);
        this.contractFormService.showHistoryList = !this.contractFormService.showHistoryList
       // this.selectedStepData={contractGuid:this.contractGuid,contractStep :null}
        this.contractDataService.subContractStepToOpenOne.next({contractGuid:this.contractGuid,contractStep :null})
      })
    }
    onReloadContract(){
      this.contractDataService.subContractStepToOpenOne.next({contractGuid:this.contractGuid,contractStep :null})
      this.contractDataService.subContractReloadContract.next(true)
    }
    onRoadMapVersionChanged(data: {label:string, roadmap:ContractRoadmapModel}){
      let activeRoadMapGuid = this.contractData?.contract?.roadmap_active.guid 
      if (data.roadmap.guid === this.contractRoadmapCurrent?.guid  && data.roadmap.guid === activeRoadMapGuid ) {
         this.contractFormService.showHistoryList = !this.contractFormService.showHistoryList
        return
      }
      if ( this.contractRoadmapCurrent?.guid === activeRoadMapGuid && data.roadmap.guid !== activeRoadMapGuid) {
        this.contractDataService.activeRoadMapClone = structuredClone(this.contractRoadmapCurrent)
      }
      if (data.roadmap.guid !== this.contractRoadmapCurrent?.guid  && data.roadmap.guid === activeRoadMapGuid ) {
        this.contractRoadmapCurrent = this.contractDataService.activeRoadMapClone
      } else {
        this.contractRoadmapCurrent = data.roadmap
      }
      this.contractData? this.contractData.rights.isContractBlockedForEdit = data.roadmap.guid !== this.contractData?.contract?.roadmap_active.guid : null;
      let contractTitle = this.contractData!.contract!.contract.name + (this.contractData?.rights?.isContractBlockedForEdit? ' версия от ' : ''  + data.label)
      this.contractNameFC.patchValue(contractTitle)
      this.contractDataService.subContractBlockEdit.next(this.contractData?.rights?.isContractBlockedForEdit||true)
      this.contractGetTargetDataService.getStepTargetData(this.contractRoadmapCurrent!.steps!,this.contractDataService.currentMember?.guid!,this.contractGuid)
      .subscribe(()=>this.contractDataService.subAlltargetDataIsLoaded.next(true));
      this.contractFormService.showHistoryList = !this.contractFormService.showHistoryList

    }
    saveContractName() {
      this.contractFormService.checkInterDomainRedirect(this.contractData?.contract?.contract).subscribe(()=>{
        this.contractFormService.saveEditedContractDescription(this.contractGuid,{
                        name:this.contractNameFC.value ||'',
                        description:this.contractData!.contract!.contract.description
        }).subscribe(()=>{
          this.contractData!.contract!.contract.name = this.contractNameFC.value!
          this.contractNameFC.setValue(this.contractData!.contract!.contract.name )
        })
      })
    }
    onCloneContract() {
      this.formState='Submitting'
      this.contractData?.contract? 
        this.contractActionsMainService.cloneContract(this.contractData).subscribe(()=>this.formState='Default')
        : null;
    }
    deleteContract() {
      this.contractFormService.checkInterDomainRedirect(this.contractData?.contract?.contract).subscribe(()=>{
        this.contractData?.contract? this.contractActionsMainService.deleteContract(this.contractData?.contract.contract, this.contractDataService.currentMember!) : null
      })
    }
    onSignContract() {
      this.contractFormService.checkInterDomainRedirect(this.contractData?.contract?.contract).subscribe(()=>{
        if (this.contractData?.contract?.roadmap_active.steps) {
          this.contractDataService.subContractFormState.next('Submitting')
          this.contractActionsMainService.signContract(this.contractData?.contract?.roadmap_active.steps,this.contractData.rights.isUserVerifiedContract,this.contractGuid)
          .subscribe(()=>this.contractData!.rights.isUserVerifiedContract = !this.contractData?.rights.isUserVerifiedContract )
        }
      })
    }
    onRegoniciate() {
      this.contractFormService.checkInterDomainRedirect(this.contractData?.contract?.contract).subscribe(()=>{
        this.contractData? this.contractActionsMainService.renegotiateContract(this.contractData) : null
      })
    }
    returnToContactTable() {
        let routeData = this.contractDataService.bSubContractTableRoute.value
        this.router.navigate(routeData? routeData : ['account','contracts','all','all_statuses'])
    }
    openDescriptionEditor () {
      this.contractFormService.checkInterDomainRedirect(this.contractData?.contract?.contract).subscribe(()=>{
        let ckEditorRef = this.dialog.open(CkeditorComponent,{
            panelClass:'contract-ckeditor-padding-modalbox',
            minHeight:'50vh',
            minWidth:'50vw'
        })
        ckEditorRef.componentInstance.inputData = this.contractData?.contract?.contract.description||''
        ckEditorRef.componentInstance.isShowEditor = true
        ckEditorRef.componentInstance.emitFinish
        .pipe(
            tap(data=>data[0]? this.contractData!.contract!.contract.description = data[1] : null),
            switchMap(
                data=>data[0]? this.contractFormService.saveEditedContractDescription(this.contractGuid,{
                    name:this.contractData!.contract!.contract.name,
                    description:data[1]
                    }) : of(null)),
            tap(()=>ckEditorRef.close()))
        .subscribe(data=>this.cds.detectChanges())
      })
    }
    goToGraphView() {
      this.contractDataService.isGraphShown = !this.contractDataService.isGraphShown
    }
}